<template>
  <div class="container">
    <div class="row">
      <div class="col-4">
        <div class="content-login">
          <div class="card">
            <div class="card-header bg--dark-blue">
              <h2 class="card-title">Bienvenido al Portal de Clientes Eco-Lógica</h2>
            </div>
            <div class="card-body login">
              <!-- <div class="alert alert-warning" role="alert" >
                <b>¡IMPORTANTE!</b>
                                 Recuerde que el proceso de revisión anual de la declaración 2020 en SINADER está en curso. Hay plazo hasta el <b>10 de septiembre</b> para realizarla.

              </div> -->

              <div class="form" v-show="showRecuperar">
                <div class="content-login row justify-content-center ">
                  <div class="card-body login">
                      <div class="logo"></div>
                      <div class="form">
                        <div class="form-floating mb-3 mt-2">
                          <input class="form-control" v-model="loginData.username" placeholder="Usuario">
                          <label for="floatingInput">Usuario</label>
                        </div>
                        <br />
                        <button type="button" class="btn btn-primary justify-content-center w-100 " @click="recuperar" :disabled="isSend">Recuperar</button>
                        <small>Se le enviará un correo con la nueva clave</small>
                        <div class="mt-3 text-center">
                          <a href="#" @click="showRecuperar=false">Volve a Login</a>
                        </div>
                      </div>
                  </div>
                </div>
              </div>

              <div class="form" v-show="!showRecuperar">
                <div class="content-login row justify-content-center" >
                  <div class="card-body login">
                    <div class="form">
                      <div class="form-floating mb-3  w-100">
                        <input class="form-control" v-model="loginData.username" placeholder="Usuario">
                        <label for="floatingInput">Usuario</label>
                      </div>
                      <div class="form-floating mb-3  w-100">
                        <input type="password" class="form-control" v-model="loginData.password" placeholder="Clave">
                        <label for="floatingInput">Clave</label>
                      </div>
                      <br />
                      <!-- <div v-show="loginError" class="alert alert-warning  justify-content-center w-100" role="alert" >
                        Credenciales incorrectas
                      </div> -->
                      <button type="button" class="btn btn-primary  justify-content-center w-100" @click="loginFuncionario">Ingresar</button>
                    </div>
                    <div class="mt-3 text-center">
                      <a href="#" @click="showRecuperar=true" class="text-primary" ><span >¿Olvide mi contraseña?</span></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { utils } from '@/utils.js'

export default {
  mixins: [utils],
  name: 'Home',
  components: { },
  data () {
    return {
      showRecuperar: false,
      loginError: false,
      loginSuccess: false,
      loginData: { username: null, password: null },
      isSend: false
    }
  },
  mounted () {
    this.getUser()
    // localStorage.removeItem('jwt.access')
    // localStorage.removeItem('jwt.refresh')
    // this.$store.commit('putUser', null)
  },

  methods: {
    // tryLogin () {
    //   if (this.$route.fullPath.search('logout') >= 0) { return }
    //   var url = '/api/token/refresh/'
    //   var refreshKey = localStorage.getItem('jwt.refresh')
    //   if (!refreshKey || refreshKey === '') { return }
    //   axios({ method: 'post', url: url, data: { refresh: refreshKey } }).then(resp => {
    //     console.log(resp.data)
    //     localStorage.setItem('jwt.access', resp.data.access)
    //     localStorage.setItem('jwt.refresh', resp.data.refresh)
    //     var redirect = this.$route.query.redirect || 'Calendario'
    //     this.$router.push({ name: redirect })
    //     // location.reload()
    //   }).catch(error => {
    //     this.logOut()
    //     console.log(error)
    //   }
    //   )
    // },

    getUser () {
      axios.get('/users/info').then(res => {
        this.$store.commit('putUser', res.data)
        this.user = res.data
        this.$router.push('/cartola')
      })
    },

    recuperar () {
      console.log('recuperar pass')
      if (this.loginData.username === '') return this.errorNotification('Debe Ingresar un Usuario')
      this.isSend = true
      const url = `/users/recover/${this.loginData.username}`
      axios.get(url).then(res => {
        this.successNotification(res.data.message)
      }).catch(error => {
        this.errorNotification(error.response.data.message)
        console.log(error.response.data.message)
      }).finally(() => { this.isSend = false })
    },

    loginFuncionario (e) {
      e.preventDefault()
      var url = '/api/token/'
      this.loginError = false
      axios({
        method: 'post',
        url: url,
        data: {
          username: this.loginData.username,
          password: this.loginData.password
        }
      })
        .then(response => {
          localStorage.setItem('jwt.access', response.data.access)
          localStorage.setItem('jwt.refresh', response.data.refresh)
          this.getUser()
        })
        .catch(response => {
          this.error = response
          this.loginError = true
          this.errorNotification('Las Credenciales Son Incorrectas')
        })
    }
  }
}
</script>
